import { contentInstance } from './client';
import * as gamesApi from './games';
import * as imagesApi from './images';
import * as setsApi from './sets';
import * as tagsApi from './tags';
import * as unitsApi from './units';
import * as usersApi from './users';

// Re-export all the individual APIs for direct use
export * from './games';
export * from './images';
export * from './sets';
export * from './tags';
export * from './units';
export * from './users';

// Export the ContentAPI class for backward compatibility
export class ContentAPI {
  // Sets
  static getSets = setsApi.getSets;
  static getSetSections = setsApi.getSetSections;
  static attachPremiumSet = setsApi.attachPremiumSet;
  static detachPremiumSet = setsApi.detachPremiumSet;
  static getSetDetail = setsApi.getSetDetail;
  static getSyncedUnitsForPack = setsApi.getSyncedUnitsForPack;
  static setSyncedUnitsForPack = setsApi.setSyncedUnitsForPack;
  static createSet = setsApi.createSet;
  static updateSet = setsApi.updateSet;
  static getGamesPerUnit = setsApi.getGamesPerUnit;
  static setGamesPerUnit = setsApi.setGamesPerUnit;
  static deleteSet = setsApi.deleteSet;

  // Units
  static getUnit = unitsApi.getUnit;
  static getSetsForUnit = unitsApi.getSetsForUnit;
  static syncSetsForUnit = unitsApi.syncSetsForUnit;
  static deleteSetFromUnit = unitsApi.deleteSetFromUnit;

  // Games
  static getGames = gamesApi.getGames;
  static getGame = gamesApi.getGame;
  static updateGame = gamesApi.updateGame;

  // Images
  static uploadImage = imagesApi.uploadImage;
  static updateImage = imagesApi.updateImage;
  static removeImage = imagesApi.removeImageFromSet;

  // Tags
  static getTags = tagsApi.getTags;

  // Users
  static getUser = usersApi.getUser;
  static getSetsForUser = usersApi.getSetsForUser;

  // Activity
  static getUnitActivity = unitsApi.getUnitActivity;
}

// Export the contentInstance for direct use
export { contentInstance };
